export const washington = {
  "53000": "Washington",
  "53001": "Adams County",
  "53003": "Asotin County",
  "53005": "Benton County",
  "53007": "Chelan County",
  "53009": "Clallam County",
  "53011": "Clark County",
  "53013": "Columbia County",
  "53015": "Cowlitz County",
  "53017": "Douglas County",
  "53019": "Ferry County",
  "53021": "Franklin County",
  "53023": "Garfield County",
  "53025": "Grant County",
  "53027": "Grays Harbor County",
  "53029": "Island County",
  "53031": "Jefferson County",
  "53033": "King County",
  "53035": "Kitsap County",
  "53037": "Kittitas County",
  "53039": "Klickitat County",
  "53041": "Lewis County",
  "53043": "Lincoln County",
  "53045": "Mason County",
  "53047": "Okanogan County",
  "53049": "Pacific County",
  "53051": "Pend Oreille County",
  "53053": "Pierce County",
  "53055": "San Juan County",
  "53057": "Skagit County",
  "53059": "Skamania County",
  "53061": "Snohomish County",
  "53063": "Spokane County",
  "53065": "Stevens County",
  "53067": "Thurston County",
  "53069": "Wahkiakum County",
  "53071": "Walla Walla County",
  "53073": "Whatcom County",
  "53075": "Whitman County",
  "53077": "Yakima County",
};
